/* script */
//
//
//
//
//
//
//

// Components
import ApiPath from 'docs/components/apis/ApiPath.vue';

/**
 * This component is used to show the list of API tags.
 *
 * @vue-prop {String} baseUrl the base URL to perform the call to
 * @vue-prop {Object[]} tags a list of API and routes tags
 * @vue-prop {Object} [definitions] an optional list of objects definitions
 *
 * @category docs.components.apis
 * @exports Tags
 * @component
 */
const __vue_script__ = {
    name: 'Tags',

    components: { ApiPath },

    props: {
        baseUrl: {
            type: String,
            required: true
        },

        tags: {
            type: Object,
            default: () => ({})
        },

        definitions: {
            type: Object,
            default: () => ({})
        },

        secDefinitions: {
            type: Object,
            default: () => ({})
        },

        security: {
            type: Array,
            default: () => []
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags"},_vm._l((_vm.tags),function(tag,name){return _c('div',{staticClass:"tag"},[_c('h3',[_vm._v(_vm._s(_vm.$utils.strings.capitalize(_vm.$utils.strings.humanize(name))))]),_c('vue-markdown',{staticClass:"description"},[_vm._v(_vm._s(tag.description))]),_vm._l((tag.paths),function(route,path){return _c('api-path',{attrs:{"base-url":_vm.baseUrl,"route":route,"path":path,"definitions":_vm.definitions}})})],2)}),0)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Tags.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__